import { Box } from "@mui/material";

import { settingsPagePaddingSx } from "~/features/settings/settings.styles";
import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import UpdateConfiguration from "./UpdateConfiguration";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function UpdateConfigurationPage({ viewTitle }: Props) {
  useNavbar({ viewTitle });
  return (
    <Box sx={[settingsPagePaddingSx, { pt: 3, maxWidth: "100%", minWidth: 0 }]}>
      <UpdateConfiguration />
    </Box>
  );
}
